import { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from 'services/firebase';

const UserLocationContext = createContext();

export const UserLocationProvider = ({ children }) => {
  const { user } = useAuth();
  const [userData, setUserData] = useState(null);
  const [currentLocation, setCurrentLocation] = useState({
    name: '',
    city: '',
    country: '',
    region: ''
  });

  useEffect(() => {
    const fetchUserData = async () => {
      if (user) {
        try {
          const userDocRef = doc(db, "users", user.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            const data = userDoc.data();
            setUserData(data);
            
            // Check for session-specific location first
            const sessionKey = `tempLocation_${user.uid}`;
            const sessionLocation = sessionStorage.getItem(sessionKey);
            console.log("Checking session storage with key:", sessionKey);
            console.log("Session storage value:", sessionLocation);
            
            if (sessionLocation) {
              console.log("Session location found:", sessionLocation);
              const tempLoc = JSON.parse(sessionLocation);
              setCurrentLocation({
                name: data.firstName || user.displayName || '',
                ...tempLoc
              });
              console.log("Updated location with session location:", tempLoc);
            } else {
              console.log("No session location found, using user data:", data)
              setCurrentLocation({
                name: data.firstName || user.displayName || '',
                city: data.city || '',
                country: data.country || '',
                region: data.region || ''
              });
            }
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      } else {
        setUserData(null);
        setCurrentLocation({ name: '', city: '', country: '', region: '' });
        if (user) {
          sessionStorage.removeItem(`tempLocation_${user.uid}`);
        }
      }
    };
    fetchUserData();
  }, [user]);

  const updateLocation = (updates) => {
    console.log("Updating location with:", updates);
    setCurrentLocation(prev => ({ ...prev, ...updates }));
    
    // Save temporary location to session storage
    if (user) {
      const sessionKey = `tempLocation_${user.uid}`;
      const currentTemp = sessionStorage.getItem(sessionKey);
      const tempLocation = currentTemp ? JSON.parse(currentTemp) : {};
      const newTempLocation = { ...tempLocation, ...updates };
      sessionStorage.setItem(sessionKey, JSON.stringify(newTempLocation));

      console.log('SAVED SESSION STORAGE with key:', sessionKey);
      console.log('TEMP LOCATION:', JSON.stringify(newTempLocation));
    }
    
    console.log("Updated location:", currentLocation);
  };

  return (
    <UserLocationContext.Provider value={{
      userData,
      currentLocation,
      updateLocation,
      userName: currentLocation.name,
      userCity: currentLocation.city,
      userCountry: currentLocation.country,
      userRegion: currentLocation.region
    }}>
      {children}
    </UserLocationContext.Provider>
  );
};

export const useUserLocation = () => {
  const context = useContext(UserLocationContext);
  if (!context) {
    throw new Error('useUserLocation must be used within UserLocationProvider');
  }
  return context;
};